var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6C6 6.55228 5.55228 7 5 7C4.44772 7 4 6.55228 4 6C4 5.44772 4.44772 5 5 5C5.55228 5 6 5.44772 6 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7C8.55228 7 9 6.55228 9 6C9 5.44772 8.55228 5 8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12 6.55228 11.5523 7 11 7C10.4477 7 10 6.55228 10 6C10 5.44772 10.4477 5 11 5C11.5523 5 12 5.44772 12 6Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66933 0C1.62529 0 0 1.81388 0 3.88511V8.11488C0 10.1866 1.62511 12 3.66933 12H8.00609L11.4937 15.8363C11.6326 15.9892 11.8513 16.0408 12.0439 15.9664C12.2366 15.8919 12.3636 15.7066 12.3636 15.5V11.9998C14.3919 11.9805 16 10.1752 16 8.11488V3.88511C16 1.81409 14.3742 0 12.3307 0H3.66933ZM1 3.88511C1 2.29831 2.24307 1 3.66933 1H12.3307C13.7565 1 15 2.29857 15 3.88511V8.11488C15 9.70185 13.7567 11 12.3307 11H11.8636C11.5875 11 11.3636 11.2239 11.3636 11.5V14.2067L8.59724 11.1637C8.50248 11.0594 8.36814 11 8.22727 11H3.66933C2.24284 11 1 9.70211 1 8.11488V3.88511Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.67a96500c0289416c6f3aabacc5da30a.svg";
export { ForwardRef as ReactComponent };